"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlockchainEnvironment = void 0;
const notifi_axios_utils_1 = require("@notifi-network/notifi-axios-utils");
// TODO: Deprecate
var BlockchainEnvironment;
(function (BlockchainEnvironment) {
    BlockchainEnvironment[BlockchainEnvironment["MainNetBeta"] = 0] = "MainNetBeta";
    BlockchainEnvironment[BlockchainEnvironment["TestNet"] = 1] = "TestNet";
    BlockchainEnvironment[BlockchainEnvironment["DevNet"] = 2] = "DevNet";
    BlockchainEnvironment[BlockchainEnvironment["LocalNet"] = 3] = "LocalNet";
})(BlockchainEnvironment = exports.BlockchainEnvironment || (exports.BlockchainEnvironment = {}));
const useNotifiConfig = (env = 'Production') => {
    let notifiEnv;
    switch (env) {
        case BlockchainEnvironment.MainNetBeta:
            notifiEnv = 'Production';
            break;
        case BlockchainEnvironment.TestNet:
            notifiEnv = 'Staging';
            break;
        case BlockchainEnvironment.DevNet:
            notifiEnv = 'Development';
            break;
        case BlockchainEnvironment.LocalNet:
            notifiEnv = 'Local';
            break;
        default:
            notifiEnv = env;
    }
    const { gqlUrl, storagePrefix } = (0, notifi_axios_utils_1.notifiConfigs)(notifiEnv);
    return {
        gqlUrl,
        storagePrefix,
    };
};
exports.default = useNotifiConfig;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlTm90aWZpQ29uZmlnLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vbGliL2hvb2tzL3VzZU5vdGlmaUNvbmZpZy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFDQSwyRUFBbUU7QUFFbkUsa0JBQWtCO0FBQ2xCLElBQVkscUJBS1g7QUFMRCxXQUFZLHFCQUFxQjtJQUMvQiwrRUFBVyxDQUFBO0lBQ1gsdUVBQU8sQ0FBQTtJQUNQLHFFQUFNLENBQUE7SUFDTix5RUFBUSxDQUFBO0FBQ1YsQ0FBQyxFQUxXLHFCQUFxQixHQUFyQiw2QkFBcUIsS0FBckIsNkJBQXFCLFFBS2hDO0FBRUQsTUFBTSxlQUFlLEdBQUcsQ0FDdEIsTUFBaUQsWUFBWSxFQUM3RCxFQUFFO0lBQ0YsSUFBSSxTQUE0QixDQUFDO0lBQ2pDLFFBQVEsR0FBRyxFQUFFO1FBQ1gsS0FBSyxxQkFBcUIsQ0FBQyxXQUFXO1lBQ3BDLFNBQVMsR0FBRyxZQUFZLENBQUM7WUFDekIsTUFBTTtRQUNSLEtBQUsscUJBQXFCLENBQUMsT0FBTztZQUNoQyxTQUFTLEdBQUcsU0FBUyxDQUFDO1lBQ3RCLE1BQU07UUFDUixLQUFLLHFCQUFxQixDQUFDLE1BQU07WUFDL0IsU0FBUyxHQUFHLGFBQWEsQ0FBQztZQUMxQixNQUFNO1FBQ1IsS0FBSyxxQkFBcUIsQ0FBQyxRQUFRO1lBQ2pDLFNBQVMsR0FBRyxPQUFPLENBQUM7WUFDcEIsTUFBTTtRQUNSO1lBQ0UsU0FBUyxHQUFHLEdBQUcsQ0FBQztLQUNuQjtJQUVELE1BQU0sRUFBRSxNQUFNLEVBQUUsYUFBYSxFQUFFLEdBQUcsSUFBQSxrQ0FBYSxFQUFDLFNBQVMsQ0FBQyxDQUFDO0lBRTNELE9BQU87UUFDTCxNQUFNO1FBQ04sYUFBYTtLQUNkLENBQUM7QUFDSixDQUFDLENBQUM7QUFFRixrQkFBZSxlQUFlLENBQUMifQ==